/**
 * @class   Config
 * @brief   The Config library for keeping Configuration options and resource strings
 * @details
 * @version   0.1
 * @date  02/04/2016
 */
var Config = (function() {

  /**
   * @brief A string containing the key used within local storage.
   */
  var _currentLanguageStorageKey = "current_lang";

  /**
   * @brief A string defining the language resource.
   */
  var _language = "en";

  /**
   * @brief An object containing all the language resources for the application.
   */
  var _langResources = {
    en : {
      universal: {
        region: "Region",
        country: "Country",
        Indicator: "Indicator",
        special: "Special",
        total: "Total",
        unweightedDen: "Unweighted denominator",
        number: "Number",
        Measure: "Measure",
        Definition: "Definition",
        Denominator: "Denominator",
        Group: "Group",
        Universe: "Universe",
        Type: "Type",
        Decimals: "Decimals",
        Indicator_ID: "Indicator ID",
        higher: " and higher",
        upTo: "Up to ",
        to: " to ",
        loading: "Loading Data...",
        surveySelector: "", // empty on purpose
        country: "Country",
        survey: "Survey",
        total: "Total",
        by: 'By',
        characteristic: "Characteristic",
        requestingMap: 'Requesting map data...',
        loaded: "Loaded",
        records: 'Records',
        share: 'Share',
        indicatorPopupTitle: "Indicator Details",
        noData: "No Data",
        selectIndicators: "Select Indicators",
        selectCountries: "Select Countries",
        breaks: "Breaks",
        mobileDetected: "Mobile Detected",
        World: "World",
        Percent: "Percent",
        Denominators: "Denominators",
        WeightedDen: 'Weighted Denominators',
        UnweightedDen: 'Unweighted Denominators',
        introNext: 'Next',
        introPrev: 'Previous',
        introClose: 'Close',
        introHide: 'Do not show me again',
        IndicatorSpecial1Id: "Denominator Special 1 Id",
        IndicatorSpecial2Id: "Denominator Special 2 Id",
        DenominatorWeightedId: "Denominator Weighted Id",
        IndicatorTotalId: "Denominator Total Id",
        DenominatorUnweightedId: "Denominator Unweighted Id",
        All: "All",
        Mixed: "Mixed",
        None: "None",
        excelExportHeader: ["Country Code", "Country Name", "Survey Year", "Survey Name", "Indicator", "By Variable", "Characteristic Category", "Characteristic Label", "Value"],
        iUnderstand: "Got it!",
        Error: "Error",
        invalidCustomBreaks: "Invalid Custom Breaks",
        customBreakTitle: "Custom Break Points",
      },
      guidedhelp: {
        mainPageTour1: "<div id='introJSindex'><b>Select your country or<br>countries of interest<b></div>",
        ctryTour1: "<div id='introJSindex'>Select your country/countries of interest: " +
                    "<ul class='introJSlist'><li>Filter by region of the world OR</li>" +
                    "<li>Select through an alphabetic list of all countries</li></ul></div>",
        indicatorTour1: "<div id='indIntro'>Three ways to select indicators: <br> <ol class='introJSlist' type='a'><li><strong>Most Common Indicators:</strong> This list features approximately " +
                              " 20 of the most commonly used DHS indicators, organized by the order they are typically found in a final report.<br></li>" +
                              "<li><strong>Indicators by tag</strong>: These indicators are grouped by common international indicator sets or topics." +
                              "</li><li><strong>Complete list:</strong> This tree structure represents a list of all the tables in DHS final reports. Click through the topics (by clicking " +
                              " on the triangle) in the tree to find your precise indicator of interest.</li></ol></div>",
        gridTour1: "<div id='drawerIntro'>Add a new indicator with the pencil icon. <br><br><i>Adding a new indicator will close Guided Help. Restart with the Guided Help link at the top of the page.</i><br></div>",
        gridTour10: "<div id='drawerIntro'>Check or uncheck countries from your list to change your table display. Add a new country to your selection with the pencil icon. <br><br><i>Adding a new country will close Guided Help. Restart with the Guided Help link at the top of the page.</i><br></div>",
        gridTour2: "<div id='drawerIntro'>Customize your survey selection: <ol class='introJSlist' type='a'><li>Limit your table to the 1 or 2 most recent surveys<br></li><li>To see a time period that isn’t the most recent, select a customized set of surveys</li></ol></div>",
        gridTour3: "<div id='drawerIntro'>Add background characteristics to disaggregate the data in the table. Check the circle next to your characteristic of interest to add it, click again to remove.</div>",
        gridTour4: "<div id='drawerIntro'>Get more information (precise definition, denominator, etc.) on your chosen indicator.</div>",
        gridTour5: "<div id='drawerIntro'>Click on the up and down triangles at the top of the column to sort your data from high to low or low to high. <br><br><i>This action will close guided help.</i><br></div>",
        gridTour6: "<div id='drawerIntro'>Use the Options tab to pivot the view of your table by survey, indicators, characteristics or add denominator values.</div>",
        gridTour7: "<div id='drawerIntro'>Export your table in a table format (e.g. to use in Excel) or a database format.</div>",
        gridTour8: "<div id='drawerIntro'>Share your table on social media, by email, or copy the URL to visit this custom table again in the future.</div>",
        gridTour9: "<div id='drawerIntro'>See your data in column chart.</div>",
        colTour1: "<div id='drawerIntro'>Check/Uncheck background characteristics and countries to customize your data visualization<br></div>",
        colTour2: "<div id='drawerIntro'>Use the Options tab to customize the look of your chart: <br> <ol type='a'><li>Add or remove the legend<br></li><li>Add grid lines</li><li>Add the y axis<br></li><li>Add or remove data point labels<br></li></ol></div>",
        colTour3: "<div id='drawerIntro'>Export your chart as a PDF or PNG. <br><br> Customize your export by changing the size of your fonts</div>",
        colTour4: "<div id='drawerIntro'>Share your chart on social media, by email, or copy the link for future use<br></div>",
        colTour5: "<div id='drawerIntro'>Mouse over any bar for a summary of the data. <br><br><i>Guided help must be closed to use this feature.</i><br></div>",
        colTour6: "<div id='drawerIntro'>See your data in a line graph.</div>",
        lineTour1: "<div id='drawerIntro'>Check/Uncheck background characteristics and countries to customize your data visualization<br></div>",
        lineTour2: "<div id='drawerIntro'>Use the Options tab to customize the look of your chart: <br> <ol class='introJSlist' type='a'><li>Add or remove the legend<br></li><li>Add grid lines</li><li>Add the y axis<br></li><li>Add or remove data point labels<br></li></ol></div>",
        lineTour3: "<div id='drawerIntro'>Export your chart as a PDF or PNG. <br><br> Customize your export by changing the size of your fonts</div>",
        lineTour4: "<div id='drawerIntro'>Share your chart on social media, by email, or copy the link for future use<br></div>",
        lineTour5: "<div id='drawerIntro'>Mouse over any line for a summary of the data<br><br><i>Guided help must be closed to use this feature.</i><br></div>",
        lineTour6: "<div id='drawerIntro'>See your data in a map.</div>",
        mapTour1: "<div id='drawerIntro'>Toggle between your already selected indicators<br></div>",
        mapTour2: "<div id='drawerIntro'>Zoom in/zoom out</div>",
        mapTour3: "<div id='drawerIntro'>Select subnational level to see the range of data across the country</div>",
        mapTour4: "<div id='drawerIntro'>Change type and number of data breaks - categorize your data categories in different ways.</div>",
        mapTour5: "<div id='drawerIntro'>Change the color scheme.</div>",
        mapTour6: "<div id='drawerIntro'>Change to light background or remove labels</div>",
        mapTour7: "<div id='drawerIntro'><ol class='introJSlist' type='a'><li>Export a map to print, and customize your map view and title</li><li>Export a map shapefile</li></ol></div>",
        mapTour8: "<div id='drawerIntro'>Share your map on social media, by email, or copy the link for future access. </div>",
        mapTour9: "<div id='drawerIntro'>Click on country for data pop-up displaying trends or subnational data. <br><br> <i>This action will close Guided Help. Restart with the Guided Help link at the top of the page</i></div>"
      }
    },  //END English
    fr : {
      universal: {
        region: "Région",
        country: "Pays",
        Indicator: "Indicateur",
        special: "Spécial",
        total: "Totale",
        unweightedDen: "Dénominateur non pondéré",
        number: "Nombre",
        Measure: "Mesure",
        Definition: "Définition",
        Denominator: "Dénominateur",
        Group: "Groupe",
        Universe: "Univers",
        Type: "Genre",
        Decimals: "Précision décimale",
        Indicator_ID: "Code de l'indicateur",
        higher: " et plus",
        upTo: "De ",
        to: " à ",
        loading: "Chargement des données",
        surveySelector: "", // empty on purpose
        country: "Pays",
        survey: "Enquête",
        total: "Total",
        by: "Par",
        characteristic: "Caractéristiques",
        requestingMap: "Demande de données de carte",
        loaded: "",
        records: " données chargées",
        share: "Partager",
        indicatorPopupTitle: "Détails de l'indicateur",
        noData: "Pas de données",
        selectIndicators: "Sélectionner des indicateurs",
        selectCountries: "Sélectionner des pays",
        breaks: "Groupes",
        mobileDetected: "Mobile Détecté",
        World: "Monde",
        Percent: "Pour cent",
        Denominators: 'Dénominateurs',
        WeightedDen: 'Dénominateurs pondérés',
        UnweightedDen: 'Dénominateurs non pondérés',
        introNext: 'Suivant',
        introPrev: 'Précédent',
        introClose: 'Fermer',
        introHide: 'Ne plus me montrer cela',
        IndicatorSpecial1Id: "Dénominateurs spécial 1 Id",
        IndicatorSpecial2Id: "Dénominateurs spécial 2 Id",
        DenominatorWeightedId: "Dénominateurs pondérés Id",
        IndicatorTotalId: "Dénominateurs Total Id",
        DenominatorUnweightedId: "Dénominateurs non pondérés Id",
        All: "Tout",
        Mixed: "Mixte",
        None: "Aucun",
        excelExportHeader: ["Code indicateur", "Nom du pays", "Année de l'enquête", "Nom de l'enquête", "Indicateurr", "Par variable", "Indicateurs pondérés", "Indicateurs non pondérés", "Catégorie caractéristique", "Label caractéristique", "Valeur"],
        iUnderstand: "J'ai compris!",
        Error: "Erreur",
        invalidCustomBreaks: "Pauses personnalisées non valides",
        customBreakTitle: "Points d'arrêt personnalisés",

      },
      guidedhelp: {
        mainPageTour1: "<div id='introJSindex'>Sélectionner les pays qui vous intéressent</div>",
        ctryTour1: "<div id='introJSindex'>Sélectionner les pays/indicateurs qui vous intéressent : <ul class='introJSlist'><li>Filtrer par région OU</li><li>sélectionner d’une liste alphabétisée de tous les pays</li></ul></div>",
        indicatorTour1: "<div id='indIntro'>Trois manières de sélectionner les indicateurs : <br> <ol class='introJSlist' type='a'>" +
                          "<li><strong>Indicateurs populaires : </strong>" +
                          "Cette liste comprend une sélection d’environ 20 des indicateurs EDS les plus fréquemment utilisés, organisés dans l’ordre dans lequel on les trouve typiquement dans un rapport final.<br></li>" +
                          "<li><strong>Indicateurs par mot clé : </strong>" +
                          "Ces indicateurs sont regroupés selon des sujets ou des domaines d'indicateurs internationaux courants." +
                          "</li><li><strong>Liste complète : </strong>" +
                          "Cette structure arborescente représente une liste de tous les indicateurs dans une configuration similaire à celle des tableaux dans les rapports EDS finaux.</li></ol></div>",
        gridTour1: "<div id='drawerIntro'>Ajouter un nouvel indicateur avec l’icône crayon. <br><br><i>Choisir un nouveau indicateur fermera l’aide guidée. Pour recommencer, cliquez sur l’Aide Guidée en haut.</i><br></div>",
        gridTour10: "<div id='drawerIntro'>Cocher/décocher des pays de votre liste pour changer l’affichage de votre tableau. Ajouter un nouveau pays avec l’icône crayon. <br><br><i>Choisir un nouveau pays fermera l’aide guidée. Pour recommencer, cliquez sur l’Aide Guidée en haut.</i><br></div>",
        gridTour2: "<div id='drawerIntro'>Personnaliser votre sélection d’enquêtes : <ol class='introJSlist' type='a'>" +
                      "<li>Limiter votre tableau à l’une ou deux enquêtes les plus récentes<br></li>" +
                      "<li>Pour consulter une période n'étant pas la plus récente, sélectionnez un ensemble d'enquêtes sur mesure</li></ol></div>",
        gridTour3: "<div id='drawerIntro'>Ajouter des caractéristiques sociodémographiques pour désagréger les données dans le tableau. Cliquer dans le cercle à côté de la caractéristique désirée pour l’ajouter,  cliquer encore pour la retirer du tableau.</div>",
        gridTour4: "<div id='drawerIntro'>Obtenir de plus amples informations sur l'indicateur que vous avez choisi (définition, dénominateur, etc.).</div>",
        gridTour5: "<div id='drawerIntro'>Cliquer sur les triangles à la en-tête de la colonne pour trier les données de bas en haut ou de haut en bas. <br><br><i>Cette action fermera l’aide guidée. Pour recommencer, cliquez sur l’Aide Guidée en haut.</i><br></div>",
        gridTour6: "<div id='drawerIntro'>Utiliser les options pour pivoter la vue de votre tableau par enquête, indicateurs, caractéristiques sociodémographiques, ou pour ajouter les dénominateurs.</div>",
        gridTour7: "<div id='drawerIntro'>Exporter vos données dans un tableau (pour utiliser en Excel) ou une base de données.</div>",
        gridTour8: "<div id='drawerIntro'>Partager votre tableau sur les réseaux sociaux ou par courriel, ou copier l'URL pour consulter le tableau sur mesure à l'avenir.</div>",
        gridTour9: "<div id='drawerIntro'>Visualiser vos données dans une histogramme.</div>",
        colTour1: "<div id='drawerIntro'>Cocher/décocher des caractéristiques sociodémographiques et pays pour personnaliser votre visualisation des données<br></div>",
        colTour2: "<div id='drawerIntro'>Utiliser les Options pour personnaliser l’apparence de la graphique: <br> <ol type='a'>" +
                    "<li>Ajouter ou retirer la légende<br></li>" +
                    "<li>Ajouter de la quadrillage</li>" +
                    "<li>Ajouter l’axe des ordonnées (y)<br></li>" +
                    "<li>Ajouter ou retirer les étiquettes des points de données<br></li></ol></div>",
        colTour3: "<div id='drawerIntro'>Exporter votre graphique au format PDF ou PNG. <br><br> Personnaliser votre exportation en changeant la taille de police</div>",
        colTour4: "<div id='drawerIntro'>Partager votre graphique sur les réseaux sociaux ou par courriel, ou copier l'URL pour consulter le graphique sur mesure à l'avenir<br></div>",
        colTour5: "<div id='drawerIntro'>Faire glisser la souris sur une colonne pour obtenir un résumé des données. <br><br>" +
                    "<i>Cette action n’est pas possible si l’Aide Guidée est activée.</i><br></div>",
        colTour6: "<div id='drawerIntro'>Visualiser vos données dans une graphique linéaire.</div>",
        lineTour1: "<div id='drawerIntro'>Cocher/décocher des caractéristiques sociodémographiques et pays pour personnaliser votre visualisation des données.<br></div>",
        lineTour2: "<div id='drawerIntro'>Utiliser les Options pour personnaliser l’apparence de la graphique: <br> <ol class='introJSlist' type='a'>" +
                    "<li>Ajouter ou retirer la légende<br></li>" +
                    "<li>Ajouter de la quadrillage</li>" +
                    "<li>Ajouter l’axe des ordonnées (y)<br></li>" +
                    "<li>Ajouter ou retirer les étiquettes des points de données<br></li></ol></div>",
        lineTour3: "<div id='drawerIntro'>Exporter votre graphique au format PDF ou PNG. <br><br> Personnaliser votre exportation en changeant la taille de police</div>",
        lineTour4: "<div id='drawerIntro'>Partager votre graphique sur les réseaux sociaux ou par courriel, ou copier l'URL pour consulter le graphique sur mesure à l'avenir<br></div>",
        lineTour5: "<div id='drawerIntro'>Faire glisser la souris sur une ligne pour obtenir un résumé des données. <br><br>" +
                      "<i>Cette action n’est pas possible si l’Aide Guidée est activée.</i><br></div>",
        lineTour6: "<div id='drawerIntro'>Visualiser vos données dans une carte.</div>",
        mapTour1: "<div id='drawerIntro'>Basculer entre des indicateurs sélectionnés pour choisir les éléments à visualiser<br></div>",
        mapTour2: "<div id='drawerIntro'>Zoom avant/Zoom arrière</div>",
        mapTour3: "<div id='drawerIntro'>Afficher des données au niveau infranational pour voir la gamme des données dans un pays.</div>",
        mapTour4: "<div id='drawerIntro'>Changer le type et le nombre de catégories pour classer vos données de différentes manières.</div>",
        mapTour5: "<div id='drawerIntro'>Changer votre modèle de couleur.</div>",
        mapTour6: "<div id='drawerIntro'>Change au style léger ou retirer les étiquettes de strate.</div>",
        mapTour7: "<div id='drawerIntro'><ol class='introJSlist' type='a'><li>Exporter votre carte pour imprimer et personnaliser l’apparence et titre de la carte</li>" +
                    "<li>Exporter un shapefile de la carte</li></ol></div>",
        mapTour8: "<div id='drawerIntro'>Partager votre carte sur les réseaux sociaux ou par courriel, ou copier l'URL pour consulter la graphique sur mesure à l'avenir. </div>",
        mapTour9: "<div id='drawerIntro'>Cliquer sur un pays pour ouvrir une fenêtre contextuelle affichant des tendances ou des données infranationales. <br><br><i>Cette action fermera l’aide guidée. Pour recommencer, cliquez sur l’Aide Guidée en haut.</i></div>"
      }
    } //END French
  };

  /**
  * @fn     _getLocaleStrCmpFn
  * @brief  Returns a function for custom locale string comparison and sorting.
  * @details    var cmpFn = getLocaleStrCmpFn(['AaÁá','Bb','Cc','Dd','EeÉé']); //...
  *             var arr = ["ác", "Áa", "AD", "aB"];
  *             arr.sort(cmpFn); //"Áa", "aB", "ác", "AD"
  *             Rest of non included characters are compared against the startChar parameter,
  *             which by default is the first character of the string's array provided.
  * @return   A function that can be used for sorting.
  */
  var _getLocaleStrCmpFn = function(orderArr, startChar) {
    var map = [];
    for (var i = 0; i < orderArr.length; i++) {
      var chars = '' + orderArr[i];
      for (var j = 0; j < chars.length; j++) {
        if (startChar === undefined) {
          startChar = chars.charAt(j);
        }
        map[chars.charAt(j)] = i + 1;
      }
    }

    return function(a, b) {
      a = '' + a;
      b = '' + b;
      var len = a.length < b.length ? a.length : b.length;
      var ca, cb, va, vb;
      for (var i = 0; i < len; i++) {
        ca = a.charAt(i);
        cb = b.charAt(i);
        va = map[ca];
        vb = map[cb];
        if (va && vb) {
          if (va > vb) return 1;
          else if (va < vb) return -1;
        }
        else {
          if (va) ca = startChar;
          if (vb) cb = startChar;
          if (ca > cb) return 1;
          else if (ca < cb) return -1;
        }
      }
      if (a.length > b.length)
        return 1;
      else if (a.length < b.length)
        return -1;
      return 0;
    };
  }

  return {
    /**
     * @fn      setLanguage
     * @brief   Sets the language for the controllers when obtaining text to display.
     * @details Allows a user to set the language so that the correct resource strings can be obtained.
     * @param   language: a LANGUAGE type to be passed into the function to set the language.
     * @return  void
     */
    setLanguage: function(language) {
      //Set Language.
      if(typeof language === 'undefined') {
        _language = Config.LANGUAGE.ENGLISH;
      }
      else {
        _language = language;
      }

      //Save language choice in local storage.
      window.localStorage.setItem(Config.getStorageKey(),_language);
    },

    /**
     * @fn      getLanguage
     * @brief   Gets the language set in the application.
     * @details Allows a user to get the language that is currently set.
     * @return  string containing the language abbreviation. Used for input to other functions in the Config Class.
     */
    getLanguage: function() {
      return _language;
    },

    /**
     * @fn      getAvailableLanguages
     * @brief   Gets all the languages available for the Application.
     * @details Allows a user to display a list of available languages.
     * @return  An array of objects containing the name/value pair of languages and their respective coes.
     */
    getAvailableLanguages: function() {
      //Declare Important Variables.
      var arrLangProps = [];
      var arrLangLabels = [] ;
      var arrLangs = [] ;

      //Set the language properties to obtain the proper values. Always use English.
      arrLangProps = Config.LANGUAGE_LABELS["en"];

      //Obtain the language labels in the appropriate current language.
      arrLangLabels = Config.LANGUAGE_LABELS[_language];

      //Create an array of objects with the proper information.
      for(var nIndex in arrLangLabels) {
          var objTemp = {};
          objTemp["label"] = arrLangLabels[nIndex];
          objTemp["value"] = Config.LANGUAGE[arrLangProps[nIndex].toUpperCase()];
          arrLangs.push(objTemp);
      }

      //Return array.
      return arrLangs;
    },

    getRegionLabels: function() {
      return Config.REGION_LABELS[_language];
    },


    getResourceStrings: function(controllerName) {
      return _langResources[_language][controllerName];
    },

    getGuidedHelpString: function(resourceID) {
      return _langResources[_language]["guidedhelp"][resourceID];
    },

    /**
     * @fn      getUniversalString(resourceID)
     * @brief   Obtains string specified by the resource id in the current language.
     * @details Allows a user to obtain universal / not page-specific strings for the app.
     * @return  An string specified by the resource id in the current language.
     */
    getUniversalString: function(resourceID) {
      return _langResources[_language]["universal"][resourceID];
    },

    /**
     * @fn      getStorageKey
     * @brief   Gets the storage key used to store the language for the App.
     * @details Sets the current language name stored in the permanent local storage.
     * @return  string containing the key name for the local storage object containing the current language.
     */
    getStorageKey: function() {
      return _currentLanguageStorageKey;
    },

    updateMessage: function (downloadSize) {
      if(_language == Config.LANGUAGE.FRENCH) {
        return "Voulez-vous mettre à jour vos données, est d'environ " + App.utils.convertToMB(downloadSize) + " Mo?";
      }
      else {
        return "Would you like to update your data, it\"s approximately " + App.utils.convertToMB(downloadSize) + " MB?";
      }
    },

    downloadMessage: function (downloadSize) {
      var strFinal = "";
      if(_language == Config.LANGUAGE.FRENCH) {
        strFinal = "Voulez-vous télécharger les données de ce pays afin qu'ils puissent être utilisés en mode hors connexion? " +
                   "Les données sont d'environ " + App.utils.convertToMB(downloadSize) + " Mo.";
      }
      else {
        strFinal = "Would you like to download this country's data so they can be used offline? The data are approximately " +
                    App.utils.convertToMB(downloadSize) + " MB.";
      }
      return strFinal;
    },

    sharingMessage: function (sharingText) {
      return sharingText + " @DHSprogram visit http://dhsprogram.com/data/Mobile-App.cfm";
    },

    getLocaleStrCmpFn: function () {
      var ordES = ['AaÁá','Bb','Cc','Dd','EeÉé','Ff','Gg','Hh','IiÍí','Jj','Kk','Ll','Mm','Nn',
                    'Ññ','OoÓó','Pp','Qq','Rr','Ss','Tt','UuÚúÜü','Vv','Ww','Xx','Yy','Zz'];
      return _getLocaleStrCmpFn(ordES);
    },

    sanitizeNumberString: function(num) {

      function formatNumber(number, separator) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
      }
      if(_language == Config.LANGUAGE.FRENCH) {
        var strNum = formatNumber(num, " ")
        return strNum.replace(/\./g, ",");
      }
      else {
        var strNum = formatNumber(num, ",")
        return strNum;
      }
    },

    /**
     *  LANGUAGE: Languages supported.
     */
    LANGUAGE: {
      ENGLISH: "en",
      FRENCH: "fr"
    },

    /**
    * Locales for Angular Dynamic Locale Module
    */
    LOCALE: {
      en: 'en-us',
      fr: 'fr-fr'
    },

    /**
     *  LANGUAGE: Language labels for supported languages.
     */
    LANGUAGE_LABELS: {
      en : ['English', 'French'],
      fr : ['Anglais', 'Français']
    },

    /**
     *  REGION_LABELS: regions labels for supported languages.
     */
    REGION_LABELS: {
      en : {
        region1: "Sub-Saharan Africa",
        region2: "North Africa/West Asia/Europe",
        region3: "Central Asia",
        region4: "South & Southeast Asia",
        region5: "Latin America & Caribbean"
      },
      fr : {
        region1: "Afrique sub-saharienne",
        region2: "Afrique du Nord/Asie de l'Ouest/Europe",
        region3: "Asie Centrale",
        region4: "Asie du Sud & Sud-Est",
        region5: "Amérique Latine & Caraïbes"
      }
    },

    /**
     *  CONTROLLER: The controllers that have language resources associated with them.
     */
    CONTROLLER: {
      UNIVERSAL: "universal"
    },

    language_dictionary: _langResources,
  }//END return
}());



function trans(str){
  var lang = Config.getLanguage();
  if(lang == 'en') return str;
  var key = _.get(_.invert(Config.language_dictionary.en.universal), str);
  return _.get(Config.language_dictionary[lang].universal, key, false);
}
